import React from 'react';

import '@awesome.me/webawesome/dist/components/switch/switch.js';
import '@awesome.me/webawesome/dist/components/card/card.js';

interface MemoryEngagementProps {
  variant?: 'memory' | 'timeline';
  allowComments: boolean;
  allowReactions: boolean;
  register: Function;
  setValue: Function;
};

const MemoryEngagement: React.FC<MemoryEngagementProps> = ({ variant = 'memory', allowComments, allowReactions, register, setValue }) => {
  return (
    <div className={`memory-engagement-container inner ${variant}`}>
      {variant === 'memory' && (
        <div className="memory-engagement-header">
          <div className="page-eyebrow">
            <wa-avatar initials="5" />
            Engagement settings
          </div>
        </div>
      )}
      <div className="memory-engagement wa-stack wa-gap-xs">
        <wa-card className="memory-engagement-setting memory-engagement-reactions">
          <div className="wa-cluster">
            <div className="memory-engagement-setting-icon">
              <i className="fa-light fa-heart fa-lg" />
            </div>
            <div className="memory-engagement-setting-label">
              <label htmlFor="allowReactions">
                <p><strong>Allow reactions</strong></p>
                <span>Viewers can react with Love, Joy, Gratitude and more</span>
              </label>
            </div>
            <div className="memory-engagement-setting-switch">
              <wa-switch
                id="allowReactions"
                size="l"
                defaultChecked={allowReactions}
                value={true}
                {...register('allow_reactions')}
                onChange={() => { setValue('allow_reactions', !allowReactions, { shouldDirty: true }) }}
              ></wa-switch>
            </div>
          </div>
        </wa-card>
        <wa-card className="memory-engagement-setting memory-engagement-comments">
          <div className="wa-cluster">
            <div className="memory-engagement-setting-icon">
              <i className="fa-light fa-message fa-lg" />
            </div>
            <div className="memory-engagement-setting-label">
              <label htmlFor="allowComments">
                <p><strong>Allow comments</strong></p>
                <span>Logged-in users can leave comments on this memory</span>
              </label>
            </div>
            <div className="memory-engagement-setting-switch">
              <wa-switch
                id="allowComments"
                size="l"
                defaultChecked={allowComments}
                value={true}
                {...register('allow_comments')}
                onChange={() => { setValue('allow_comments', !allowComments, { shouldDirty: true }) }}
              ></wa-switch>
            </div>
          </div>
        </wa-card>
      </div>
    </div>
  );
}

export default MemoryEngagement;
